import React from 'react';
import EnrolledCourses from '../../../components/jsx/learnings/courses/CoursePage/EnrolledCourses/EnrolledCourses';
import CompletedCourses from'../../../components/jsx/learnings/courses/CoursePage/CompletedCourses/CompletedCourses';
import AvailableCourses from '../../../components/jsx/learnings/courses/CoursePage/AvailableCourses/AvailableCourses';
const CoursePage = () => {
  return (
    <>
      <EnrolledCourses /> 
      <CompletedCourses /> 
      <AvailableCourses />
    </>
  );
};

export default CoursePage;